<template>
  <div class="user-info">
    <div>
      <a-menu mode="inline" :defaultSelectedKeys="defaultSelectedKeys" @click="change" style="width: 150px;float: left;margin-top: 20px;">
         <a-menu-item key="1">
          个人中心
        </a-menu-item>
<!--        <a-menu-item key="2">-->
<!--          信息查看记录-->
<!--        </a-menu-item>-->
         <a-menu-item key="4">
          报告记录
        </a-menu-item>
        <a-menu-item key="3">
          充值记录
        </a-menu-item>

      </a-menu>
      <div style="width: 1000px;margin-left: 20px;float: left;margin-top: 20px">
        <div v-if="this.nowKey=='1'">
          <user-info></user-info>
        </div>
<!--        <div v-if="this.nowKey=='2'">-->
<!--          <check-log></check-log>-->
<!--        </div> -->
        <div v-if="this.nowKey=='3'">
          <pay-log></pay-log>
        </div>
        <div v-if="this.nowKey=='4'">
          <report-log></report-log>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import SearchLog from "@/views/user/SearchLog";
import CheckLog from "@/views/user/CheckLog";
import PayLog from "@/views/user/PayLog";
import ReportLog from "@/views/user/ReportLog";
import UserInfo from "@/views/user/UserInfo";
export default {
  name: "User",
  components: {
    UserInfo,
    SearchLog,
    CheckLog,
    PayLog,
    ReportLog
  },
  data() {
    return {
      nowKey: '1',
      defaultSelectedKeys:['1']
    };
  },
  methods: {
    change(openKeys) {
      this.nowKey = openKeys.key;
    },
  },
}
</script>

<style scoped>
.user-info {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
  min-height: calc(100vh - 240px);
}
</style>
